import { render } from "./ToggleSwitch.vue?vue&type=template&id=38a9fe0f"
import script from "./ToggleSwitch.vue?vue&type=script&lang=js"
export * from "./ToggleSwitch.vue?vue&type=script&lang=js"

import "./ToggleSwitch.vue?vue&type=style&index=0&id=38a9fe0f&lang=css"

import exportComponent from "/Users/mhall/dev/rorserver/newcomb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__